import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
// Your web app's Firebase configuration
const config = {
  apiKey: 'AIzaSyBGsxdDsu6rmFAu3NOfVxxItRr4WNwdE14',
  authDomain: 'danko-v1.firebaseapp.com',
  databaseURL: 'https://danko-v1.firebaseio.com',
  projectId: 'danko-v1',
  storageBucket: 'danko-v1.appspot.com',
  messagingSenderId: '317272169734',
  appId: '1:317272169734:web:33abccd817adc6be',
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(config);

// Export firestore database
export default firebaseApp.firestore();
export const firebaseAuth = firebaseApp.auth();
